<template>
  <div
    v-if="props.xl"
    class="grid place-content-center grid-cols-1 gap-4 m-auto text-darkGray-2"
    :class="horizontal && 'grid-cols-[auto,1fr] gap-4 justify-items-center'"
  >
    <i class="place-self-center fas fa-circle-notch fa-spin text-5xl"></i>
    <div class="place-self-center" v-if="!noPendingText">
      <p v-if="props.customText" class="w-full text-3xl">
        {{ props.customText }}
      </p>
      <p v-else class="w-full text-3xl">Laddar...</p>
    </div>
  </div>
  <div
    v-else-if="props.xs"
    class="grid place-items-center"
    :class="
      horizontal &&
      !noPendingText &&
      'grid-cols-[auto,1fr] gap-2 justify-items-center'
    "
  >
    <i class="fas fa-circle-notch animate-spin text-base"></i>
    <div v-if="!noPendingText">
      <p v-if="props.customText">{{ customText }}</p>
      <p v-else>Laddar...</p>
    </div>
  </div>
  <div
    v-else
    class="grid place-items-center"
    :class="horizontal && 'grid-cols-[auto,1fr] gap-2 justify-items-center'"
  >
    <i class="fas fa-circle-notch animate-spin text-2xl"></i>
    <div v-if="!noPendingText">
      <p v-if="props.customText">{{ customText }}</p>
      <p v-else>Laddar...</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";

const props = defineProps<{
  horizontal?: boolean;
  customText?: string;
  noPendingText?: boolean;
  xl?: boolean;
  xs?: boolean;
}>();
</script>
